import React from "react";
import { RouteComponentProps } from "react-router";
import { CONTRACT_SLIDER, ContractViewLocation } from "@navigation/locations";
import { checkIfDirectRoute } from "@utils/navigationUtils";

type Props = RouteComponentProps<any>;

export function ContractViewerWrapper(props: Props) {
  const { match } = props;
  const { url } = match;

  return <>{catchDirectUrl(url)}</>;
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(`${url}/:id?`, CONTRACT_SLIDER, ({ id }) => {
    if (id) {
      return new ContractViewLocation(id);
    }
  });
}
